import { get, post, request } from '@/api/request';

const URI = "/trad"

// 列表
export const listTrad = (page, size, params) => post(`${URI}/lists?page=${page}&size=${size}`, params);
export const listCope = (page, size, params) => post(`${URI}/listCope?page=${page}&size=${size}`, params);

// 编辑
export const edit = params => post(`${URI}/edit`, params);
export const editCope = params => post(`${URI}/editCope`, params);
// 修改金额
export const operate = params => post(`${URI}/operate`, params);
// 流水
export const listBussiness = id => get(`${URI}/bussiness/${id}`);
// 删除
export const deleteById = id => get(`${URI}/delete/${id}`);
export const deleteCope = id => get(`${URI}/deleteCope/${id}`);
// 撤回
export const rollback = id => get(`${URI}/rollback/${id}`);





// WEBPACK FOOTER //
// ./src/api/ticket/trad.js